import React from 'react';
import { InputBase, InputGroup } from '@milanote/roma';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { LABEL_NAME_MAX_LENGTH } from '../../../../../../../common/labels/labelConstants';

type Props = {
    value: string;
    onChange: (value: string) => void;
    handleSearchSubmit: () => void;
};

const LabelsSearchBar = ({ value, onChange, handleSearchSubmit }: Props) => {
    const translate = useTranslator('popup', 'labels.search');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        handleSearchSubmit();
    };

    return (
        <div className="LabelsSearchBar mb-3">
            <form onSubmit={handleSubmit}>
                <InputGroup size="sm" onChange={onChange} aria-label="Enter label name">
                    <InputBase
                        name="label-search"
                        type="text"
                        placeholder={translate('placeholder')}
                        value={value}
                        maxLength={LABEL_NAME_MAX_LENGTH}
                        autoComplete="off"
                    />
                </InputGroup>
            </form>
        </div>
    );
};

export default LabelsSearchBar;
